/*
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-11-18 14:33:18
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2023-11-18 16:39:13
 * @FilePath: \xyjh-web\src\config\useVant.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import { Icon, Popup, Form, Field, Dialog, Uploader, Button } from "vant";
import "vant/lib/index.css";
Vue.use(Form);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Uploader);
